import { loadable } from '../../../components/loadable';
import { Spinner } from '../../../components/Spinner/Spinner';

export const LoadableCohortSwitchingMenu = loadable(
  () => import(/* webpackChunkName: "CohortSwitchingMenu" */ './component'),
  {
    loading: Spinner,
    key: 'ConnectedCohortSwitchingMenu',
  }
);
